export default __webpack_public_path__ + "36b7b2cbd482c04ebb8f4103de5c71fe.png";